export const arthropodSpeciesList = [
    'ARAN',
    'AUCH',
    'BLAT',
    'CHIL',
    'COLE',
    'CRUS',
    'DERM',
    'DIEL',
    'DIPT',
    'HETE',
    'HYMA',
    'HTMB',
    'LEPI',
    'MANT',
    'ORTH',
    'PSEU',
    'SCOR',
    'SOLI',
    'THYS',
    'UNKI',
    'MICRO',
];

export const arthropodFenceTraps = ['A4', 'B4', 'C4'];

export const testSessionData = {
    captureStatus: 'withCaptures',
    array: '1',
    project: 'Gateway',
    site: 'GWA1',
    handler: 'FFF',
    recorder: 'FFF',
};

export const amphibianFenceTraps = [
    'A1',
    'A2',
    'A3',
    'A4',
    'A-Fence',
    'B2',
    'B3',
    'B4',
    'B-Fence',
    'C2',
    'C3',
    'C4',
    'C-Fence',
];

export const amphibianSpecies = ['BUAL', 'BUCD', 'BUPU', 'BUWU', 'INAL', 'SCCO', 'UNKA'];

export const sexOptions = ['Male', 'Female', 'Unknown'];

export const lizardSpeciesList = ['ASTI', 'CADR', 'COVA', 'ASSO'];

export const mammalSpeciesList = ['DOGE', 'FELI', 'MONK'];

export const mammalFenceTraps = ['X1', 'X2', 'X3'];
